




































































import {Component} from "vue-property-decorator";
import {Api} from "@/core/services/MedicaPro/Api";
import BaseComponent from "@/core/components/BaseComponent";
import {Client} from "@/core/services/MedicaPro/models";
import ClientDetailsPageHeaderView
    from "@/components/Admin/Clients/Details/Components/ClientDetailsPage-HeaderView.vue";
import ClientDetailsPageMeasurementListView
    from "@/components/Admin/Clients/Details/Components/MeasurementList/ClientDetailsPage-MeasurementListView.vue";
import ClientDetailsPagePrescriptionListView
    from "@/components/Admin/Clients/Details/Components/PrescriptionList/ClientDetailsPage-PrescriptionListView.vue";
import ClientDetailsPageBloodPressureListView
    from "@/components/Admin/Clients/Details/Components/BloodPressureList/ClientDetailsPage-BloodPressureListView.vue";
import ClientDashboard from "@/components/Admin/Clients/Details/Components/ClientDashboard/ClientDashboard.vue";
import bus from "@/main";

@Component({
    components: {
        ClientDashboard,
        ClientDetailsPageBloodPressureListView,
        ClientDetailsPagePrescriptionListView,
        ClientDetailsPageMeasurementListView, ClientDetailsPageHeaderView}
})
export default class ClientDetailsPage extends BaseComponent {

    // Bindings to view
    public isReady = false;
    public tab = 'symptoms';
    public name?: string;
    public presetMeasurementIdentifiers: string[] | null = null;

    // Data
    private item?: Client;

    public created() {
        bus.$on('filterByMeasurementIdentifier', (category: string, identifier: string) => {
             this.tab = category;
             this.presetMeasurementIdentifiers = [identifier];
        });
    }

    public mounted() {
        this.parseRoute();
    }

    public parseRoute() {
        this.tab = this.$route.params.tab;
        if (!this.isReady) {
            this.loadData();
        }
    }

    protected loadData() {
        Api.clients().getById(parseInt(this.$route.params.clientId)).find(patient => {
            this.item = patient[0];
            this.renderView();
        });
    }

    private renderView() {
        this.name = this.item?.name;
        document.title = this.name ?? '';
        this.isReady = true;
    }

    public tabChange() {
        this.presetMeasurementIdentifiers = null;
        this.$route.params.tab = this.tab;
    }

}
